import { Button, Flex, Text } from "@mantine/core";
import { useController, useFormContext } from "react-hook-form";
import CustomInput from "src/generator/CustomInput/CustomInput";
import FileAttachment from "src/generator/FileAttachment/FileAttachment";

interface Props {
  id: string;
  type: string;
  text: string;
  filename: string;
  filetype: string;
  b64: string;
  label: string;
}

const BATItem = ({ id, type, text, filename, filetype, b64, label }: Props) => {
  const { control } = useFormContext();
  const {
    field: { value: typeValue, onChange: onTypeChange },
  } = useController({
    name: `${id}.type`,
    control,
    defaultValue: type,
  });

  const handleSetType = (type: string) => () => onTypeChange(type);

  if (!typeValue) {
    return (
      <Flex align="center" gap="sm">
        <Text>{label}</Text>
        <Button variant="outline" compact onClick={handleSetType("attachment")}>
          Y
        </Button>
        <Button variant="outline" compact onClick={handleSetType("text")}>
          N
        </Button>
      </Flex>
    );
  } else if (typeValue === "text") {
    return (
      <CustomInput
        w="100%"
        id={`${id}.text`}
        value={text}
        required={false}
        width="100%"
        textarea
      />
    );
  } else if (typeValue === "attachment") {
    return (
      <FileAttachment
        id={id}
        filename={filename}
        filetype={filetype}
        b64={b64}
      />
    );
  }
  return <></>;
};

export default BATItem;
